import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export enum OptionSelectedState {
  NO, PARTIALLY, YES
}

type OptionSelectedType = boolean | OptionSelectedState

export interface IOption<T extends OptionSelectedType> {
  id: string
  label: React.ReactNode
  value: string
  selected: T
  parent?: boolean
  disabled?: boolean
}

export interface IOptGroup<T extends OptionSelectedType> {
  id: string
  label: React.ReactNode
  options: IOption<T>[]
}
